import type { JSX, ReactNode } from 'react'
import { Button } from 'primereact/button'

interface FilterSidebarProps {
  title?: string
  children: ReactNode
  onClear?: () => void
}

export function FilterSidebar({ title = 'Filters', children, onClear }: FilterSidebarProps): JSX.Element {
  return (
    <aside className="w-60 shrink-0 border-r border-gray-200 p-4" aria-label={title}>
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold uppercase text-gray-500">{title}</h3>
        {onClear && <Button label="Clear" link size="small" onClick={onClear} />}
      </div>
      <div className="flex flex-col gap-3">
        {children}
      </div>
    </aside>
  )
}

export default FilterSidebar
